import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Layout from '../../../components/global/layout';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import './style.scss';
import { useSelector } from 'react-redux';
import methodModel from '../../../methods/methods';
import rolesModel from '../../../models/roles.model';
import PhoneInput from 'react-phone-input-2';

const SubAdminDetail = (p) => {
  const history = useNavigate();
  const user = useSelector((state) => state.user);
  const { id, userId } = useParams();
  const [data, setData] = useState();
  const [Permissions, setPermission] = useState({});
  const getDetail = (did) => {
    loader(true);
    ApiClient.get(`user/detail`, { id: did }).then((res) => {
      if (res.success) {
        setData(res.data);
      }
      loader(false);
    });
  };

  const getPermission = () => {
    ApiClient.get('permission/user-base', { user_id: id }).then((res) => {
      if (res.success) {
        setPermission(res?.data);
        
      }
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    getDetail(userId ? userId : id);
    if (id) getPermission();
  }, [id, userId]);

  return (
    <Layout>
      <div className="pprofile1 shadow-lg">
        <div className="flex items-center mb-8">
          <button
            type="button"
            class="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"
            to="/users"
            onClick={back}
          >
            <i class="fa fa-angle-left text-lg"></i>
          </button>
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">
              View Sub Admin
            </h3>
            <p className="text-sm font-normal text-[#525252]">
              Here you can see all about your Sub Admin
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Name</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && data?.fullName}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Mobile No.</label>
            <PhoneInput
              value={data?.dialCode + data?.mobileNo || ''}
              // minLength={10}

              disabled
            />
            {/* <div className="pprofiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              ({data && data.dialCode}) {data && data?.mobileNo}
            </div> */}
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Email</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && data?.email}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Role</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {/* {data && rolesModel.name(data.role)} */}
              {data &&
                methodModel.capitalizeFirstLetter(
                  data?.role == 'subadmin' ? 'Sub Admin' : ''
                )}
            </div>
          </div>

          {data?.address ? (
            <div className="col-span-12 md:col-span-6">
              <label className="profileheddingcls">Address</label>
              <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
                {data && data?.address}
              </div>
            </div>
          ) : null}
          {data?.image ? (
            <div className="col-span-12 md:col-span-12">
              <label className="profileheddingcls">Image</label>
              <div>
                <div className="imagethumbWrapper">
                  <img
                    src={methodModel.noImg(data && data?.image, 'users')}
                    className="thumbnail w-[120px] h-[120px] rounded-lg p-1 shadow-md object-contain"
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <div className="border_div border-b-[1px] border-dashed border-[#A12238] mt-5 mb-5"></div>
        <div className="">
          <div className=" white-bg-main">
            <div className=" white-head ">
              <h5 className="profileheddingcls">Permissions</h5>
            </div>
            {Permissions && (
              <>
                <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase dark:text-gray-400">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        ></th>
                        <th scope="col" className="px-6 py-3">
                          <span className="">Read</span>
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        >
                          <span className=""> Add</span>
                        </th>
                        <th scope="col" className="px-6 py-3 ">
                          <span className=""> Edit</span>
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        >
                          <span className=""> Delete</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b border-gray-200 dark:border-gray-700">
                        <th
                          scope="row"
                          class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800"
                        >
                          Users
                        </th>
                        <td className="px-6 py-4">
                          <span class="material-icons rights-ic ">
                            {Permissions?.user_get ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        >
                          <span class="material-icons rights-ic ">
                            {Permissions?.user_add ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span class="material-icons rights-ic ">
                            {Permissions?.user_edit ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        >
                          <span class="material-icons rights-ic ">
                            {Permissions?.user_delete ? 'done' : 'clear'}
                          </span>
                        </td>
                      </tr>
                      <tr className="border-b border-gray-200 dark:border-gray-700">
                        <th
                          scope="row"
                          class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800"
                        >
                          Category
                        </th>
                        <td className="px-6 py-4">
                          <span class="material-icons rights-ic ">
                            {Permissions?.category_get ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        >
                          <span class="material-icons rights-ic ">
                            {Permissions?.category_add ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span class="material-icons rights-ic ">
                            {Permissions?.category_edit ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        >
                          <span class="material-icons rights-ic ">
                            {Permissions?.category_delete ? 'done' : 'clear'}
                          </span>
                        </td>
                      </tr>
                      <tr className="border-b border-gray-200 dark:border-gray-700">
                        <th
                          scope="row"
                          class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800"
                        >
                          Blogs
                        </th>
                        <td className="px-6 py-4">
                          <span class="material-icons rights-ic ">
                            {Permissions?.blog_get ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        >
                          <span class="material-icons rights-ic ">
                            {Permissions?.blog_add ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span class="material-icons rights-ic ">
                            {Permissions?.blog_edit ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        >
                          <span class="material-icons rights-ic ">
                            {Permissions?.blog_delete ? 'done' : 'clear'}
                          </span>
                        </td>
                      </tr>
                      <tr className="border-b border-gray-200 dark:border-gray-700">
                        <th
                          scope="row"
                          class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800"
                        >
                          Course
                        </th>
                        <td className="px-6 py-4">
                          <span class="material-icons rights-ic ">
                            {Permissions?.course_get ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        >
                          <span class="material-icons rights-ic ">
                            {Permissions?.course_add ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span class="material-icons rights-ic ">
                            {Permissions?.course_edit ? 'done' : 'clear'}
                          </span>
                        </td>
                        <td
                          scope="col"
                          className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                        >
                          <span class="material-icons rights-ic ">
                            {Permissions?.course_delete ? 'done' : 'clear'}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SubAdminDetail;
